<template>
  <SelectBase @select="login" @gotoLogin="gotoLogin" />
</template>
<script lang="ts" setup>
import SelectBase from './base.vue';
// import { redirectTo } from '~/utils'
const showAccountType = useAccountType();

const route = useRoute();

function login() {
  showAccountType.value = null;
  // if (route.name === 'login') {
  //   const redirect = route.query.redirect as string
  //   redirectTo(redirect)
  // }
  setTimeout(() => {
    location.reload();
  }, 500);
}

function gotoLogin() {
  showAccountType.value = null;

  if (route.name === 'login') {
    return;
  }

  setTimeout(() => {
    goLogin();
  }, 50);
}
</script>
